/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SAVE_BANK_ACCOUNT } from "../graphql/saveBankAccountDetail.mutation"
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISaveBankAccountMethods extends IPluginMethodMap {
  saveBankAccount(args: SaveBankAccountProps): Promise<any>;
}

export interface SaveBankAccountProps {
  accHolderName: string;
  bankName: string;
  accountNo: string;
  swiftCode?: string;
  type?: string;
  chequeLeaf: {
    doc: string;
    fileType: string;
    status?: string;
    name: string;
    type?: string;
  };
}

export class SaveBankAccountService implements IAgentPlugin {
  readonly methods: ISaveBankAccountMethods;

  constructor() {
    this.methods = {
      saveBankAccount: this.saveBankAccount.bind(this),
    };
  }

  async saveBankAccount(args: SaveBankAccountProps) {
    console.log("Saving bank account data", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: SAVE_BANK_ACCOUNT,
          variables: {
            input: {
              accHolderName: args.accHolderName,
              accountNo: args.accountNo,
              bankName: args.bankName,
              swiftCode: args.swiftCode,
              type: args.type,
              chequeLeaf: args.chequeLeaf,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data) {
          return { data: res?.data };
        }
      }
    } catch (err: any) {
      console.error("Error saving bank account:", err);
      throw err;
    }

    return { data: null };
  }
}
